import {PrintSettings, UnitDataSettings, ReportRequest, DownloadRequest} from '../types';
import {omit, pick} from 'underscore';

export class GenerateService {
	public generateReport(
		unitDataSettings: UnitDataSettings,
		printSettings: PrintSettings,
	): ReportRequest {
		return {
			...unitDataSettings,
			...pick(printSettings, ['carryScores', 'sortBy']),
			includeQuestionNotes: printSettings.includeNotes,
		};
	}

	public generateDownloadReport(
		printSettings: PrintSettings
	): DownloadRequest {
		return {
			...omit(printSettings, ['carryScores', 'sortBy', 'gradeScaleAllow', 'markingPeriods']),
		};
	}
}
